/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreInactivateAliases {
  FIELD_JUSTIFY = 'field-justify',
  FORM_SCORE_INACTIVATE = 'form-score-inactivate',
  LAYOUT_SCORE_INACTIVATE = 'layout-score-inactivate',
  PANEL_SCORE_INACTIVATE = 'panel-score-inactivate',
  TEXT_JUSTIFY = 'text-justify',
}
export { ScoreInactivateAliases };
